import {
  CreateQualificationListDTO,
  QualificationListJSON,
} from '@scale/shared/types/qualification/types';
import { useMutation, UseMutationResult } from 'react-query';
import apiFetch, { defaultApiFetchErrorHandler, HTTPError } from 'react-scale/lib/api-fetch';

export const useCreateQualificationLists = (
  projectId?: string,
  teamId?: string,
  onSuccess?: (data: QualificationListJSON[]) => void,
): UseMutationResult<QualificationListJSON[], unknown, CreateQualificationListDTO[]> => {
  return useMutation(
    ['createQualificationList'],
    async (qualificationLists: CreateQualificationListDTO[]) => {
      const result = await apiFetch<QualificationListJSON[]>(
        null,
        `corp-api/scalers/qualifications/lists`,
        {
          method: 'POST',
          body: {
            newQualificationLists: qualificationLists,
            projectId,
            teamId,
          },
        },
      );

      return result;
    },
    {
      onSuccess,
      onError: (err: HTTPError) => defaultApiFetchErrorHandler(err, { handleHttp: true }),
    },
  );
};
